<template>
  <div class="wrongbook-container">
    <!-- 查询控件卡片（仅日期范围） -->
    <el-card class="filter-card">
      <div class="filter-container">
        <div class="left-section">
          <el-form :inline="true" :model="searchForm" class="filter-form" size="small">
            <div class="form-content">
              <el-form-item>
                <el-date-picker
                  v-model="dateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="handleDateChange"
                  style="width: 260px">
                </el-date-picker>
              </el-form-item>
              <el-form-item class="filter-buttons">
                <el-button @click="handleReset">重置</el-button>
                <el-button type="primary" @click="handleSearch">查询</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="right-section">
          <div class="stat-card">
            <div class="stat-value">{{ totalWrongCount }}</div>
            <div class="stat-label">错题数</div>
          </div>
          <div class="stat-card">
            <div class="stat-value">{{ toFixed2(totalFixRate) }}%</div>
            <div class="stat-label">
              <span>订正率</span>
              <el-tooltip effect="dark" placement="top" content="统计口径：包含挂起题目">
                <i class="el-icon-question" style="cursor: pointer; margin-left: 4px; font-size: 14px;"></i>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </el-card>

    <!-- 数据表格卡片 -->
    <el-card class="table-card">
      <el-table
        v-loading="loading"
        :data="displayErrorList"
        stripe
        style="width: 100%"
        :header-cell-style="{
          background: '#f2f3f5',
          color: '#606266',
          fontWeight: '600',
          fontSize: '14px',
          height: '52px',
          padding: '0'
        }"
        @sort-change="handleSortChange">

        <!-- 序号列 -->
        <el-table-column type="index" label="序号" width="60" align="center">
          <template slot-scope="scope">
            {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>

        <!-- 错误类型（带 tooltip） -->
        <el-table-column prop="error_name" label="错误类型" sortable="custom" min-width="180">
          <template slot="header" slot-scope="scope">
            <span>错误类型</span>
            <el-tooltip effect="dark" placement="top" popper-class="difficulty-tooltip">
              <div slot="content" class="difficulty-tooltip-content">
                <div class="difficulty-description">
                  <p><strong>1. 算法未掌握</strong>：未掌握核心知识点、算法原理或其适用性；</p>
                  <ul>
                    <li>【学透】深入理解定义、原理、推导、复杂度</li>
                    <li>【对比】区分相似概念，明确应用场景</li>
                    <li>【复习】定期回顾基础知识</li>
                  </ul>
                  <p><strong>2. 思路/逻辑偏差</strong>：思路框架或解题逻辑有缺陷，无法构建正确解题路径；</p>
                  <ul>
                    <li>【拆解】将问题分解，逐个击破</li>
                    <li>【模拟】用小数据手动演算，验证思路</li>
                    <li>【学习】学习他人优秀解法，寻找更优思路</li>
                  </ul>
                  <p><strong>3. 实现/细节错误</strong>：思路正确，但代码细节处理不当，导致程序出错；</p>
                  <ul>
                    <li>【细抠】关注边界、初始化、数据类型、语句逻辑</li>
                    <li>【调试】熟练使用调试器，定位问题</li>
                    <li>【规范】养成良好的编码习惯</li>
                  </ul>
                  <p><strong>4. 效率/复杂度问题</strong>：算法或实现效率低，导致超时 (TLE) 或超内存 (MLE)；</p>
                  <ul>
                    <li>【估算】优先评估算法时间/空间复杂度</li>
                    <li>【优化】学习常用优化技巧（如剪枝、数据结构）</li>
                    <li>【卡点】针对性练习时间/空间敏感题</li>
                  </ul>
                  <p><strong>5. 边界/特殊情况遗漏</strong>：未考虑题目中的特殊数据、极端情况或边界条件；</p>
                  <ul>
                    <li>【预判】思考各种可能的小数据、负数、空集、全同等情况</li>
                    <li>【测试】编写专门测试边界的用例</li>
                    <li>【总结】建立边界条件检查清单</li>
                  </ul>
                  <p><strong>6. 题意理解偏差</strong>：对题目描述、要求、输入输出等理解有误；</p>
                  <ul>
                    <li>【精读】慢读、细读，划出关键词</li>
                    <li>【明确】确认输入输出格式、数据范围、约束条件</li>
                    <li>【举例】用自己的话复述题目</li>
                  </ul>
                  <p><strong>7. 工具/环境问题</strong>：编程语言特性、编译器、IDE、提交系统等非算法本身的细节问题；</p>
                  <ul>
                    <li>【熟悉】了解常用语言特性、库函数用法</li>
                    <li>【检查】留意编译警告，熟悉评测环境</li>
                    <li>【记录】记录常见坑点</li>
                  </ul>
                  <p><strong>8. 心理性错误</strong>：受情绪、心态、比赛压力等因素影响导致的技术失误；</p>
                  <ul>
                    <li>【训练】模拟赛中培养抗压能力</li>
                    <li>【调整】保持积极心态，学会自我鼓励</li>
                    <li>【暂停】遇到困难时，短暂休息，深呼吸</li>
                  </ul>
                  <p><strong>9. 其他/未分类错误</strong>：暂时难以明确归类，或属特定情况的错误；</p>
                  <ul>
                    <li>【分析】尝试将其归入现有分类</li>
                    <li>【记录】暂存，等待进一步研究或求助</li>
                  </ul>
                </div>
              </div>
              <i class="el-icon-question" style="cursor: pointer; margin-left: 4px; font-size: 14px;"></i>
            </el-tooltip>
          </template>
          <template slot-scope="{ row }">
            <span>{{ row.error_name }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="question_score_avg" label="平均得分" sortable="custom" min-width="120">
          <template slot-scope="scope">
            <div class="progress-cell">
              <span class="progress-value">{{ toFixed2(scope.row.question_score_avg) }}</span>
              <el-progress :percentage="scope.row.question_score_avg" :show-text="false" :stroke-width="5" color="#409EFF" />
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="question_score_fix_avg" label="平均订正分" sortable="custom" min-width="120">
          <template slot-scope="scope">
            <div class="progress-cell">
              <span class="progress-value">{{ toFixed2(scope.row.question_score_fix_avg) }}</span>
              <el-progress :percentage="scope.row.question_score_fix_avg" :show-text="false" :stroke-width="5" color="#67C23A" />
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="fix_rate" label="订正率" sortable="custom" min-width="120">
          <template slot-scope="scope">
            <div class="progress-cell">
              <span class="progress-value">{{ toFixed2(scope.row.fix_rate) }}%</span>
              <el-progress :percentage="scope.row.fix_rate" :show-text="false" :stroke-width="5" color="#E6A23C" />
            </div>
          </template>
        </el-table-column>

        <!-- 平均难度（带 tooltip） -->
        <el-table-column prop="avg_difficulty" label="平均难度" sortable="custom" min-width="80" align="center">
          <template slot="header" slot-scope="scope">
            <span>平均难度</span>
            <el-tooltip effect="dark" placement="top" popper-class="difficulty-tooltip">
              <div slot="content" class="difficulty-tooltip-content">
                <div class="difficulty-levels">
                  <div class="difficulty-level"><span class="level-color" style="background-color: #F56C6C;"></span><span class="level-range">00.00 ~ 14.29%:</span><span class="level-name">红题（很简单）</span></div>
                  <div class="difficulty-level"><span class="level-color" style="background-color: #E6A23C;"></span><span class="level-range">14.29 ~ 28.58%:</span><span class="level-name">橙题（简单）</span></div>
                  <div class="difficulty-level"><span class="level-color" style="background-color: #F7BA2A;"></span><span class="level-range">28.58 - 42.87%:</span><span class="level-name">黄题（较易）</span></div>
                  <div class="difficulty-level"><span class="level-color" style="background-color: #67C23A;"></span><span class="level-range">42.87 ~ 57.15%:</span><span class="level-name">绿题（中等）</span></div>
                  <div class="difficulty-level"><span class="level-color" style="background-color: #409EFF;"></span><span class="level-range">57.15 ~ 71.44%:</span><span class="level-name">蓝题（较难）</span></div>
                  <div class="difficulty-level"><span class="level-color" style="background-color: #8E44AD;"></span><span class="level-range">71.44 ~ 85.72%:</span><span class="level-name">紫题（很难）</span></div>
                  <div class="difficulty-level"><span class="level-color" style="background-color: #2C3E50;"></span><span class="level-range">85.72 ~ 100%:</span><span class="level-name">黑题（极难）</span></div>
                </div>
              </div>
              <i class="el-icon-question" style="cursor: pointer; margin-left: 4px; font-size: 14px;"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <el-tag :style="{ backgroundColor: getDifficultyColorByPercentage(scope.row.avg_difficulty), borderColor: getDifficultyColorByPercentage(scope.row.avg_difficulty), color: 'white', height: '28px', lineHeight: '26px' }" size="small">
              <span style="font-weight: bold">{{ toFixed2(scope.row.avg_difficulty) }}%</span>
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="question_nums" label="题目数" sortable="custom" min-width="80" />
        <el-table-column prop="pending_questions" label="未订正题目数" sortable="custom" min-width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.pending_questions > 0 ? 'danger' : 'success'" size="small">
              {{ scope.row.pending_questions }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleExpand(scope.row)">展开</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>

    <!-- 版权信息卡片 -->
    <el-card class="copyright-card">
      <div class="copyright-content">
        <span>Copyright © 2024 OIer之路 All rights reserved.  |  闽ICP备2025095302号-1</span>
      </div>
    </el-card>

    <!-- 抽屉组件（题目明细，仅错题） -->
    <el-drawer :visible.sync="drawerVisible" :with-header="false" size="75%" :append-to-body="false" :modal="false" :before-close="handleDrawerClose" custom-class="wrongbook-drawer">
      <div class="drawer-container">
        <div class="drawer-header">
          <h3>{{ currentError ? currentError.error_name : '' }} - 关联题目</h3>
          <el-button icon="el-icon-close" circle @click="drawerVisible = false"></el-button>
        </div>
        <el-table 
          v-loading="questionLoading" 
          :data="questionList" 
          stripe 
          style="width: 100%"
          :header-cell-style="{
            background: '#f2f3f5',
            color: '#606266',
            fontWeight: '600',
            fontSize: '14px',
            height: '52px',
            padding: '0'
          }"
          @sort-change="handleQuestionSortChange">
          <el-table-column prop="question_name" label="题目名称" min-width="180" sortable="custom">
            <template slot-scope="scope">
              <el-tooltip 
                :content="scope.row.question_name" 
                placement="top" 
                :open-delay="300"
                :disabled="!scope.row.question_name || scope.row.question_name.length < 15">
                <div class="text-ellipsis">
                  <a v-if="scope.row.question_url" :href="scope.row.question_url" target="_blank" class="link-text">{{ scope.row.question_name }}</a>
                  <span v-else>{{ scope.row.question_name }}</span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="game_name" label="赛事名称" min-width="200" sortable="custom">
            <template slot-scope="scope">
              <el-tooltip 
                :content="scope.row.game_name" 
                placement="top" 
                :open-delay="300"
                :disabled="!scope.row.game_name || scope.row.game_name.length < 20">
                <div class="text-ellipsis">
                  <a v-if="scope.row.game_url" :href="scope.row.game_url" target="_blank" class="link-text">{{ scope.row.game_name }}</a>
                  <span v-else>{{ scope.row.game_name }}</span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="question_seq" label="题号" width="75" sortable="custom" />
          <el-table-column prop="question_score" label="分数" width="100" align="center" sortable="custom">
            <template slot-scope="scope">
              <div class="score-cell">
                <span :class="{ 'score-perfect': scope.row.question_score === 100, 'score-warning': scope.row.question_score < 100 }">{{ scope.row.question_score }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="question_score_fix" label="订正分数" width="100" align="center" sortable="custom">
            <template slot-scope="scope">
              <div class="score-cell">
                <i v-if="scope.row.question_score_fix === 100" 
                   class="el-icon-medal-1" 
                   :style="{ color: getScoreColor(scope.row.question_score_fix), marginRight: '4px' }"></i>
                <span :style="{ color: getScoreColor(scope.row.question_score_fix), fontWeight: 'bold' }">
                  {{ scope.row.question_score_fix }}
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="question_level" label="题目难度" width="100" align="center" sortable="custom">
            <template slot-scope="scope">
              <el-tag :style="{ backgroundColor: getDifficultyColor(scope.row.question_level || '未定义'), borderColor: getDifficultyColor(scope.row.question_level || '未定义'), color: 'white', height: '28px', lineHeight: '26px' }" size="small">
                {{ scope.row.question_level || '未定义' }}
              </el-tag>
            </template>
          </el-table-column>

          <!-- 标签 -->
          <el-table-column prop="tags" label="标签" min-width="180">
            <template slot-scope="{ row }">
              <div class="tag-container">
                <template v-if="expandedDrawerTags[row.question_code]">
                  <!-- 展开状态：显示所有 -->
                  <el-tag
                    v-for="(tagName, idx) in row.tags"
                    :key="(tagName || idx) + '-tag'"
                    :style="{ 
                      backgroundColor: getTagColorByName(tagName), 
                      borderColor: getTagColorByName(tagName), 
                      color: 'white', 
                      height: '28px', 
                      lineHeight: '26px', 
                      marginRight: '4px', 
                      marginBottom: '4px' 
                    }">
                    {{ tagName }}
                  </el-tag>
                  <el-button
                    v-if="row.tags && row.tags.length > 1"
                    type="text"
                    class="expand-btn"
                    @click="toggleDrawerExpandTags(row.question_code)">
                    收起
                  </el-button>
                </template>
                <template v-else>
                  <!-- 收起状态：只显示第一个 -->
                  <el-tag
                    v-if="row.tags && row.tags.length > 0"
                    :style="{ 
                      backgroundColor: getTagColorByName(row.tags[0]), 
                      borderColor: getTagColorByName(row.tags[0]), 
                      color: 'white', 
                      height: '28px', 
                      lineHeight: '26px', 
                      marginRight: '4px' 
                    }">
                    {{ row.tags[0] }}
                  </el-tag>
                  <el-button
                    v-if="row.tags && row.tags.length > 1"
                    type="text"
                    class="expand-btn"
                    @click="toggleDrawerExpandTags(row.question_code)">
                    +{{ row.tags.length - 1 }}
                  </el-button>
                </template>
              </div>
            </template>
          </el-table-column>

          <!-- 操作列 -->
          <el-table-column
            label="操作"
            width="180"
            align="center"
            class-name="operation-column">
            <template slot="default" slot-scope="scope">
              <div class="operation-buttons">
                <el-tooltip content="编辑" placement="top" :enterable="false" :open-delay="100">
                  <el-button
                    type="text"
                    class="operation-button edit-button"
                    @click="handleEdit(scope.row)">
                    <i class="el-icon-edit"></i>
                  </el-button>
                </el-tooltip>

                <el-tooltip content="订正" placement="top" :enterable="false" :open-delay="100">
                  <el-button
                    type="text"
                    class="operation-button"
                    :class="scope.row.question_score_fix === 100 ? 'disabled-button' : 'fix-button'"
                    :disabled="scope.row.question_score_fix === 100"
                    @click="handleFix(scope.row)">
                    <i class="el-icon-check"></i>
                  </el-button>
                </el-tooltip>

                <el-tooltip content="复盘" placement="top" :enterable="false" :open-delay="100">
                  <el-button
                    type="text"
                    class="operation-button"
                    :class="!scope.row.has_replay ? 'disabled-button' : 'replay-button'"
                    :disabled="!scope.row.has_replay"
                    @click="openReplay(scope.row)">
                    <i class="el-icon-video-camera"></i>
                  </el-button>
                </el-tooltip>

                <el-tooltip :content="scope.row.is_collect ? '取消收藏' : '收藏'" placement="top" :enterable="false" :open-delay="100">
                  <el-button
                    type="text"
                    class="operation-button"
                    :class="scope.row.is_collect ? 'collect-active-button' : 'collect-button'"
                    @click="handleCollect(scope.row)">
                    <i :class="{'el-icon-star-off': !scope.row.is_collect, 'el-icon-star-on': scope.row.is_collect}">
                    </i>
                  </el-button>
                </el-tooltip>

                <el-tooltip :content="scope.row.is_pending ? '取消挂起' : '挂起'" placement="top" :enterable="false" :open-delay="100">
                  <el-button
                    type="text"
                    class="operation-button"
                    :class="scope.row.is_pending ? 'pending-active-button' : 'pending-button'"
                    @click="handlePending(scope.row)">
                    <i class="el-icon-video-pause">
                    </i>
                  </el-button>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="drawer-pagination-container">
          <el-pagination background @size-change="handleQuestionSizeChange" @current-change="handleQuestionCurrentChange" :current-page.sync="questionCurrentPage" :page-sizes="[20, 50, 100]" :page-size="questionPageSize" layout="total, sizes, prev, pager, next, jumper" :total="questionTotal" />
        </div>
      </div>
    </el-drawer>
    
    <!-- 复盘弹窗 -->
    <el-dialog
      :title="replayQuestionTitle ? `${replayQuestionTitle} - 复盘内容` : '复盘内容'"
      :visible.sync="replayDialogVisible"
      width="700px"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :destroy-on-close="true"
      custom-class="wrongbook-replay-dialog"
      @close="replayDialogVisible = false">
      <div v-loading="replayLoading">
        <markdown-viewer v-if="replayContent" :content="replayContent" />
        <div v-else style="color:#909399;">暂无复盘内容</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="replayDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 题目编辑对话框 -->
    <question-dialog
      :visible.sync="editDialogVisible"
      :question="currentQuestion"
      :is-edit="true"
      :game-code="currentQuestion ? currentQuestion.game_code : ''"
      :append-to-body="true"
      :modal-append-to-body="true"
      custom-class="wrongbook-edit-dialog"
      @success="handleSuccess"
      @cancel="editDialogVisible = false">
    </question-dialog>
  </div>
</template>

<script>
import { getWrongbookStatistics, getWrongbookQuestions } from '@/api/wrongbook'
import { getQuestionReplay, updateQuestionCollect, updateQuestionPending, getQuestionList } from '@/api/question'
import { getAllTags } from '@/api/tag'
import MarkdownViewer from '@/components/MarkdownViewer.vue'
import QuestionDialog from '@/views/game/components/QuestionDialog.vue'
import request from '@/utils/request'

export default {
  name: 'Wrongbook',
  components: { MarkdownViewer, QuestionDialog },
  data() {
    return {
      loading: false,
      questionLoading: false,
      errorList: [],
      displayErrorList: [],
      allQuestionList: [],
      questionList: [],
      searchForm: {
        start_time: '',
        end_time: ''
      },
      dateRange: [],
      drawerVisible: false,
      currentError: null,
      sortProp: 'error_name',
      sortOrder: 'ascending',
      currentPage: 1,
      pageSize: 20,
      total: 0,
      // 抽屉分页
      questionCurrentPage: 1,
      questionPageSize: 20,
      questionTotal: 0,
      questionSortProp: '',
      questionSortOrder: '',
      totalWrongCount: 0,
      totalFixRate: 0,
      // 标签字典（用于颜色映射）
      tagsDict: [],
      // 复盘相关
      replayDialogVisible: false,
      replayLoading: false,
      replayContent: '',
      replayQuestionTitle: '',
      // 编辑对话框相关
      editDialogVisible: false,
      currentQuestion: null,
      
      // 抽屉内的展开状态
      expandedDrawerTags: {}  // 记录抽屉内标签的展开状态
    }
  },
  created() {
    this.fetchErrorList()
    this.fetchAllTags()
  },
  mounted() {
    this.setupDialogZIndex()
  },
  methods: {
    async openReplay(row) {
      if (!row || !row.question_code) return
      this.replayDialogVisible = true
      this.replayLoading = true
      this.replayContent = ''
      this.replayQuestionTitle = row.question_name || ''
      try {
        const resp = await getQuestionReplay(row.question_code)
        if (resp && resp.code === 200) {
          this.replayContent = resp.data || ''
        } else {
          this.$message.error('获取复盘失败')
          this.replayDialogVisible = false
        }
      } catch (e) {
        this.$message.error('获取复盘失败')
        this.replayDialogVisible = false
      } finally {
        this.replayLoading = false
      }
    },
    async fetchAllTags() {
      try {
        const { data } = await getAllTags()
        this.tagsDict = data || []
      } catch (e) { this.tagsDict = [] }
    },
    toFixed2(val) {
      if (val === null || val === undefined || isNaN(val)) return '0.00'
      return Number(val).toFixed(2)
    },
    // 获取错题统计列表
    async fetchErrorList() {
      this.loading = true
      try {
        const response = await getWrongbookStatistics({
          start_time: this.searchForm.start_time,
          end_time: this.searchForm.end_time
        })
        if (response && response.code === 200 && response.data) {
          const list = (response.data || []).slice().sort((a, b) => {
            const ua = a.is_undefined ? 1 : 0
            const ub = b.is_undefined ? 1 : 0
            if (ua !== ub) return ua - ub
            return String(a.error_name || '').localeCompare(String(b.error_name || ''))
          })
          this.errorList = list
          this.total = this.errorList.length
          const wrongTotals = this.errorList.reduce((acc, r) => {
            const wrongCount = Number(r.question_nums || 0)
            acc.total += wrongCount
            acc.fixed += Math.round((Number(r.fix_rate || 0) / 100) * wrongCount)
            return acc
          }, { total: 0, fixed: 0 })
          this.totalWrongCount = wrongTotals.total
          this.totalFixRate = wrongTotals.total === 0 ? 100 : (wrongTotals.fixed / wrongTotals.total) * 100
          this.updateDisplayData()
        } else {
          this.errorList = []
          this.displayErrorList = []
          this.total = 0
          this.totalWrongCount = 0
          this.totalFixRate = 0
        }
      } catch (error) {
        console.error('获取错题统计失败:', error)
        this.$message.error('获取错题统计失败')
        this.errorList = []
        this.displayErrorList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    // 更新显示数据
    updateDisplayData() {
      this.sortErrorListData()
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      this.displayErrorList = this.errorList.slice(start, end)
    },
    // 排序
    sortErrorListData() {
      const prop = this.sortProp
      const order = this.sortOrder
      if (!prop || !order) return
      this.errorList.sort((a, b) => {
        let result = 0
        if (prop === 'pending_questions') {
          result = a.pending_questions - b.pending_questions
          if (result === 0) result = a.question_nums - b.question_nums
        } else if (typeof a[prop] === 'number') {
          result = a[prop] - b[prop]
        } else {
          result = String(a[prop]).localeCompare(String(b[prop]))
        }
        return order === 'ascending' ? result : -result
      })
    },
    // 获取抽屉数据（仅错题）
    async fetchQuestionList(params) {
      this.questionLoading = true
      try {
        let response, list = []
        
        // 先尝试使用标准的题目API，看是否包含收藏/挂起状态
        try {
          response = await getQuestionList({
            pageNum: 1,
            pageSize: 1000, // 获取足够多的数据
          start_time: this.searchForm.start_time,
          end_time: this.searchForm.end_time,
          ...params
        })
          
          console.log('使用getQuestionList API返回的完整数据:', response)
          
          // 处理getQuestionList API的返回格式：{ code: 200, data: { items: [...], total: ... } }
          if (response && response.code === 200 && response.data) {
            if (Array.isArray(response.data.items)) {
              list = response.data.items
            } else if (Array.isArray(response.data)) {
              list = response.data
            }
          }
          
          // 如果error_code参数存在，需要过滤对应的错误类型的题目
          if (params.error_code && list.length > 0) {
            list = list.filter(item => {
              // 这里需要根据实际的数据结构来过滤
              // 假设题目有error_codes字段或者其他方式关联错误类型
              return true // 临时返回所有，待后续完善
            })
          }
          
          console.log('getQuestionList解析后的题目列表:', list)
        } catch (error) {
          console.warn('getQuestionList API失败，回退到getWrongbookQuestions:', error)
          
          // 回退到原来的API
          response = await getWrongbookQuestions({
            start_time: this.searchForm.start_time,
            end_time: this.searchForm.end_time,
            ...params
          })
          
          console.log('使用getWrongbookQuestions API返回的数据:', response)
          
          // 原来的数据处理逻辑
        if (Array.isArray(response)) {
          list = response
        } else if (response && Array.isArray(response.data)) {
          list = response.data
        } else if (response && response.code === 200 && Array.isArray(response.data)) {
          list = response.data
        } else if (response && response.data && response.data.data && Array.isArray(response.data.data)) {
          list = response.data.data
        }
          
          console.log('getWrongbookQuestions解析后的题目列表:', list)
        }
        // 仅保留分数不为100的题目，并确保所有字段都正确初始化
        this.allQuestionList = list
          .filter(item => Number(item.question_score) !== 100)
          .map(item => {
            const processedItem = {
              ...item,
              // 确保Boolean字段被正确处理
              is_collect: Boolean(item.is_collect),
              is_pending: Boolean(item.is_pending),
              // 确保数字字段被正确处理
              question_score: Number(item.question_score) || 0,
              question_score_fix: Number(item.question_score_fix) || 0
            }
            
            // 调试信息：显示所有题目的原始数据和处理后的数据
            console.log('数据初始化:', {
              questionCode: item.question_code,
              questionName: item.question_name,
              originalCollect: item.is_collect,
              originalCollectType: typeof item.is_collect,
              processedCollect: processedItem.is_collect,
              originalPending: item.is_pending,
              originalPendingType: typeof item.is_pending,
              processedPending: processedItem.is_pending,
              rawItem: item  // 完整的原始数据
            })
            
            return processedItem
          })
        this.questionTotal = this.allQuestionList.length
        this.updateQuestionDisplayData()
      } catch (error) {
        console.error('获取错题明细失败:', error)
        this.$message.error('获取错题明细失败')
        this.allQuestionList = []
        this.questionList = []
        this.questionTotal = 0
      } finally {
        this.questionLoading = false
      }
    },
    updateQuestionDisplayData() {
      this.sortQuestionListData()
      const start = (this.questionCurrentPage - 1) * this.questionPageSize
      const end = start + this.questionPageSize
      // 使用Vue.set确保新的分页数据也是响应式的
      this.$set(this, 'questionList', this.allQuestionList.slice(start, end))
    },
    sortQuestionListData() {
      const prop = this.questionSortProp
      const order = this.questionSortOrder
      if (!prop || !order) return
      this.allQuestionList.sort((a, b) => {
        let result = 0
        if (prop === 'question_level') {
          const levelOrder = { '未定义': 0, '红题': 1, '橙题': 2, '黄题': 3, '绿题': 4, '蓝题': 5, '紫题': 6, '黑题': 7 }
          const levelA = a[prop] || '未定义'
          const levelB = b[prop] || '未定义'
          result = levelOrder[levelA] - levelOrder[levelB]
        } else if (typeof a[prop] === 'number') {
          result = a[prop] - b[prop]
        } else {
          result = String(a[prop]).localeCompare(String(b[prop]))
        }
        return order === 'ascending' ? result : -result
      })
    },
    // 事件处理
    handleDateChange(val) {
      if (val) {
        this.searchForm.start_time = val[0]
        this.searchForm.end_time = val[1]
      } else {
        this.searchForm.start_time = ''
        this.searchForm.end_time = ''
      }
    },
    handleSearch() {
      this.currentPage = 1
      this.fetchErrorList()
    },
    handleReset() {
      this.dateRange = []
      this.searchForm.start_time = ''
      this.searchForm.end_time = ''
      this.currentPage = 1
      this.sortProp = 'error_name'
      this.sortOrder = 'ascending'
      this.fetchErrorList()
    },
    handleExpand(row) {
      this.currentError = row
      this.fetchQuestionList({ error_code: row.error_code })
      this.drawerVisible = true
    },
    handleDrawerClose() {
      this.drawerVisible = false
    },
    handleSortChange({ prop, order }) {
      if (!order) {
        this.sortProp = 'error_name'
        this.sortOrder = 'ascending'
      } else {
        this.sortProp = prop
        this.sortOrder = order
      }
      this.updateDisplayData()
    },
    // 主表分页（缺失的事件处理）
    handleCurrentChange(val) {
      this.currentPage = val
      this.updateDisplayData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.updateDisplayData()
    },
    handleQuestionSortChange({ prop, order }) {
      this.questionSortProp = prop
      this.questionSortOrder = order
      this.updateQuestionDisplayData()
    },
    handleQuestionCurrentChange(val) {
      this.questionCurrentPage = val
      this.updateQuestionDisplayData()
    },
    handleQuestionSizeChange(val) {
      this.questionPageSize = val
      this.questionCurrentPage = 1
      this.updateQuestionDisplayData()
    },
    // 颜色映射与 Tag.vue 保持一致
    getDifficultyColor(level) {
      const colorMap = { '红题': '#F56C6C', '橙题': '#E6A23C', '黄题': '#F7BA2A', '绿题': '#67C23A', '蓝题': '#409EFF', '紫题': '#8E44AD', '黑题': '#2C3E50', '': '#909399' }
      return colorMap[level] || '#909399'
    },
    getDifficultyColorByPercentage(percentage) {
      if (percentage < 14.29) return '#F56C6C'
      if (percentage < 28.58) return '#E6A23C'
      if (percentage < 42.87) return '#F7BA2A'
      if (percentage < 57.15) return '#67C23A'
      if (percentage < 71.44) return '#409EFF'
      if (percentage < 85.72) return '#8E44AD'
      return '#2C3E50'
    },
    // 复用 Question.vue 的标签配色逻辑
    getTagColorByCode(tagCode) {
      const colors = {
        'tag-color-1': '#409EFF',
        'tag-color-2': '#67C23A',
        'tag-color-3': '#E6A23C',
        'tag-color-4': '#F56C6C',
        'tag-color-5': '#8E44AD',
        'tag-color-6': '#16A085',
        'tag-color-7': '#D35400',
        'tag-color-8': '#2980B9',
        'tag-color-9': '#27AE60',
        'tag-color-10': '#C0392B'
      }
      const classes = ['tag-color-1','tag-color-2','tag-color-3','tag-color-4','tag-color-5','tag-color-6','tag-color-7','tag-color-8','tag-color-9','tag-color-10']
      const index = parseInt(String(tagCode).split('_')[1] || '0', 36) % classes.length
      return colors[classes[index]]
    },
    getTagColorByName(tagName) {
      const tag = this.tagsDict.find(t => t.tag_name === tagName)
      return tag ? this.getTagColorByCode(tag.tag_code) : '#409EFF'
    },
    
    getScoreColor(score) {
      if (score === undefined || score === null) return '#606266';
      const percentage = (score / 100) * 100;
      if (percentage >= 100) return '#237804'; // 绿色
      if (percentage >= 75) return '#52C41A'; // 黄绿色
      if (percentage >= 50) return '#F7BA2A'; // 黄色
      if (percentage >= 25) return '#E6A23C'; // 橙色
      return '#F56C6C'; // 红色
    },
    
    // 切换抽屉内标签展开状态
    toggleDrawerExpandTags(questionCode) {
      this.$set(this.expandedDrawerTags, questionCode, !this.expandedDrawerTags[questionCode])
    },
    
    // 编辑题目
    handleEdit(row) {
      this.currentQuestion = { ...row }
      this.editDialogVisible = true
    },
    
    // 订正题目
    async handleFix(question) {
      try {
        await this.$confirm('确认将该题目订正分数改为100分吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false
        })
        
        const res = await request({
          url: `/api/game/question/${question.question_code}/fix`,
          method: 'put',
          data: {
            question_score_fix: 100
          }
        })
        
        if (res.code === 200) {
          this.$message.success('订正成功')
          // 更新本地数据
          question.question_score_fix = 100
          
          // 同时更新allQuestionList中对应的数据
          const allIndex = this.allQuestionList.findIndex(item => item.question_code === question.question_code)
          if (allIndex !== -1) {
            this.allQuestionList[allIndex].question_score_fix = 100
          }
          
        } else {
          throw new Error(res.message || '订正失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('订正失败:', error)
          this.$message.error(error.message || '订正失败')
        }
      }
    },
    
    // 收藏/取消收藏
    async handleCollect(row) {
      try {
        await this.$confirm(row.is_collect ? '确认取消收藏该题目吗？' : '确认收藏该题目吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false
        })
        
        await updateQuestionCollect(row.question_code, !row.is_collect)
        
        // 更新本地数据 - 直接更新所有相关的数据源
        const newCollectState = !row.is_collect
        
        // 更新allQuestionList中对应的数据
        const allIndex = this.allQuestionList.findIndex(item => item.question_code === row.question_code)
        if (allIndex !== -1) {
          this.$set(this.allQuestionList[allIndex], 'is_collect', newCollectState)
        }
        
        // 更新当前显示的questionList中的数据
        const displayIndex = this.questionList.findIndex(item => item.question_code === row.question_code)
        if (displayIndex !== -1) {
          this.$set(this.questionList[displayIndex], 'is_collect', newCollectState)
        }
        
        // 直接更新传入的row对象
        this.$set(row, 'is_collect', newCollectState)
        
        // 强制更新整个组件
        this.$forceUpdate()
        
        // 调试信息
        console.log('收藏状态更新:', {
          questionCode: row.question_code,
          newState: newCollectState,
          rowState: row.is_collect,
          allListState: allIndex !== -1 ? this.allQuestionList[allIndex].is_collect : 'not found',
          displayListState: displayIndex !== -1 ? this.questionList[displayIndex].is_collect : 'not found'
        })
        
        this.$message.success(newCollectState ? '收藏成功' : '取消收藏成功')
      } catch (error) {
        if (error !== 'cancel') {
          console.error('更新收藏状态失败:', error)
          this.$message.error('操作失败')
        }
      }
    },
    
    // 挂起/取消挂起
    async handlePending(row) {
      try {
        // 判断题目得分和订正分数
        if (row.question_score === 100 || row.question_score_fix === 100) {
          this.$message.warning('该题目你已经' + (row.question_score === 100 ? 'AC' : '订正') + '，无法挂起。')
          return
        }

        await this.$confirm(row.is_pending ? '确认取消挂起该题目吗？' : '确认挂起该题目吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false
        })
        
        await updateQuestionPending(row.question_code, !row.is_pending)
        
        // 更新本地数据 - 直接更新所有相关的数据源
        const newPendingState = !row.is_pending
        
        // 更新allQuestionList中对应的数据
        const allIndex = this.allQuestionList.findIndex(item => item.question_code === row.question_code)
        if (allIndex !== -1) {
          this.$set(this.allQuestionList[allIndex], 'is_pending', newPendingState)
        }
        
        // 更新当前显示的questionList中的数据
        const displayIndex = this.questionList.findIndex(item => item.question_code === row.question_code)
        if (displayIndex !== -1) {
          this.$set(this.questionList[displayIndex], 'is_pending', newPendingState)
        }
        
        // 直接更新传入的row对象
        this.$set(row, 'is_pending', newPendingState)
        
        // 强制更新整个组件
        this.$forceUpdate()
        
        // 调试信息
        console.log('挂起状态更新:', {
          questionCode: row.question_code,
          newState: newPendingState,
          rowState: row.is_pending,
          allListState: allIndex !== -1 ? this.allQuestionList[allIndex].is_pending : 'not found',
          displayListState: displayIndex !== -1 ? this.questionList[displayIndex].is_pending : 'not found'
        })
        
        this.$message.success(newPendingState ? '挂起成功' : '取消挂起成功')
      } catch (error) {
        if (error !== 'cancel') {
          console.error('挂起操作失败:', error)
          this.$message.error('操作失败')
        }
      }
    },
    
    // 编辑成功回调
    handleSuccess() {
      this.editDialogVisible = false
      // 重新获取抽屉中的数据
      this.fetchQuestionList({ error_code: this.currentError.error_code })
    },
    
    // 动态管理弹窗z-index层级，只影响特定弹窗
    setupDialogZIndex() {
      // 监听弹窗显示事件，只调整特定弹窗的z-index
      this.$nextTick(() => {
        // 监听DOM变化，当特定弹窗被添加到body时自动调整层级
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
              mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1) { // Element node
                  // 只处理弹窗容器，不影响抽屉
                  if (node.classList && node.classList.contains('el-dialog__wrapper')) {
                    // 检查是否包含我们的自定义弹窗类
                    const replayDialog = node.querySelector('.wrongbook-replay-dialog')
                    const editDialog = node.querySelector('.wrongbook-edit-dialog')
                    
                    if (replayDialog || editDialog) {
                      node.style.zIndex = '2101'
                    }
                  }
                  
                  // 只处理弹窗相关的遮罩层
                  if (node.classList && node.classList.contains('v-modal')) {
                    // 检查当前是否有我们的弹窗打开
                    if (this.replayDialogVisible || this.editDialogVisible) {
                      node.style.zIndex = '2100'
                    }
                  }
                }
              })
            }
          })
        })
        
        // 开始观察body的子节点变化
        observer.observe(document.body, {
          childList: true,
          subtree: false
        })
        
        // 组件销毁时停止观察
        this.$once('hook:beforeDestroy', () => {
          observer.disconnect()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrongbook-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  background-color: #f0f2f5;
  overflow: hidden;

  .filter-card { margin: 8px 0 0 0; flex-shrink: 0; background-color: #fff; position: relative; z-index: 10; height: 72px; 
    :deep(.el-card__body) { height: 100%; padding: 0; } }

  .filter-container { display: flex; justify-content: space-between; align-items: center; height: 100%; padding: 0 16px; }
  .left-section { display: flex; align-items: center; gap: 8px; margin-right: 20px; flex-shrink: 1; overflow-x: auto; height: 100%; }
  .filter-form { display: flex; align-items: center; white-space: nowrap; height: 100%; }
  .form-content { display: flex; align-items: center; gap: 8px; height: 100%; }
  .form-content :deep(.el-input) .el-input__inner { height: 32px; line-height: 32px; font-size: 13px; }
  .form-content :deep(.el-button) { height: 32px; line-height: 30px; padding: 0 16px; font-size: 13px; }
  .form-content .el-form-item { margin-bottom: 0; margin-right: 0; display: flex; align-items: center; }
  .filter-buttons { margin-left: auto; white-space: nowrap; }
  .filter-buttons .el-button + .el-button { margin-left: 8px; }

  .table-card { margin: 8px 0 0 0; flex: 1; display: flex; flex-direction: column; overflow: hidden; background-color: #fff; border-radius: 4px; min-height: 0; 
    :deep(.el-card__body) { height: 100%; padding: 0; display: flex; flex-direction: column; min-height: 0; } 
    :deep(.el-table) { flex: 1; height: 100%;
      .el-table__header-wrapper { position: sticky; top: 0; z-index: 2; background-color: #fff; }
      .el-table__body-wrapper { overflow-y: auto; height: calc(100% - 60px); }
      th { background-color: #f2f3f5; color: #606266; font-weight: 600; font-size: 14px; height: 52px; padding: 0; border-bottom: 1px solid #ebeef5; }
      td { padding: 8px 0; border-bottom: 1px solid #ebeef5; }
      .el-table__row { height: 52px; }
    }}

  .pagination-container { height: 40px; padding: 0 16px; background-color: #fff; border-top: 1px solid #e4e7ed; display: flex; justify-content: flex-end; align-items: center; flex-shrink: 0; }

  .right-section { display: flex; align-items: center; gap: 16px; flex-shrink: 0; padding: 0 12px; background-color: #f6f8fa; border-radius: 8px; height: 52px; }
  .stat-card { text-align: center; min-width: 80px; flex-shrink: 0; display: flex; flex-direction: column; justify-content: center; position: relative; padding: 0 10px; }
  .stat-card:not(:last-child)::after { content: ''; position: absolute; right: -8px; top: 50%; transform: translateY(-50%); height: 36px; width: 1px; background-color: #dcdfe6; }
  .stat-value { font-size: 18px; font-weight: 600; color: #1f2937; line-height: 1; margin-bottom: 4px; }
  .stat-label { font-size: 12px; color: #6b7280; line-height: 1; }

  .copyright-card { margin: 8px 0; flex-shrink: 0; background-color: #fff; border-radius: 4px; height: 40px; position: relative; z-index: 1; 
    :deep(.el-card__body) { height: 100%; padding: 0; } 
    .copyright-content { height: 100%; display: flex; align-items: center; justify-content: center; color: #909399; font-size: 14px; } }

  .drawer-container { padding: 20px; height: 100%; display: flex; flex-direction: column; overflow: hidden; 
    .drawer-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; padding-bottom: 12px; border-bottom: 1px solid #ebeef5; 
      h3 { margin: 0px 0; font-size: 22px; font-weight: 700; color: #303133; }
    }
    :deep(.el-table) { flex: 1 1 auto; display: flex; flex-direction: column; overflow: hidden; 
      .el-table__header-wrapper { position: sticky; top: 0; z-index: 2; background-color: #fff; }
      .el-table__body-wrapper { overflow-y: auto; flex: 1; padding-bottom: 12px; }
      th { background-color: #f2f3f5; color: #606266; font-weight: 600; font-size: 14px; height: 52px; padding: 0; border-bottom: 1px solid #ebeef5; }
      td { padding: 8px 0; border-bottom: 1px solid #ebeef5; }
      .el-table__row { height: 52px; }
    }
    .drawer-pagination-container { height: 48px; padding: 10px 16px 0; background-color: #fff; display: flex; justify-content: flex-end; align-items: center; flex-shrink: 0; margin-top: 5px; border-top: 1px solid #e4e7ed; }
  }
}

.progress-cell { display: flex; flex-direction: column; width: 100%; padding: 0 8px; transition: all 0.3s; }
.progress-value { margin-bottom: 8px; font-size: 15px; font-weight: 600; color: #303133; text-align: right; }
::v-deep .el-progress .el-progress-bar__outer { background-color: #f0f2f5; border-radius: 4px; }
::v-deep .el-progress .el-progress-bar__inner { border-radius: 4px; transition: width 0.6s ease; box-shadow: 0 1px 3px rgba(0,0,0,0.1); }
.score-cell { display: flex; align-items: center; justify-content: center; }
.score-perfect { color: #006400; font-weight: 600; }
.score-warning { color: #F56C6C; font-weight: 500; }


/* 抽屉样式 */
::v-deep .wrongbook-drawer { background-color: #fff !important; 
  .el-drawer__header { background-color: #fff !important; margin: 0 !important; padding: 0 !important; color: inherit !important; }
  .el-drawer__body { background-color: #fff !important; padding: 0 !important; }
}

/* tooltip 样式统一对齐 Question.vue */
.difficulty-tooltip { max-width: 600px !important; padding: 0 !important; border-radius: 6px !important; }
.difficulty-tooltip-content { max-height: none; overflow-y: visible; padding: 0; }
.difficulty-description { margin: 0; line-height: 1.6; font-size: 13px; }
.difficulty-description p { margin: 8px 0; color: #ffffff; }
.difficulty-description p strong { color: #409EFF; font-weight: 600; }
.difficulty-levels { display: flex; flex-direction: column; gap: 8px; }
.difficulty-level { display: flex; align-items: center; text-align: left; font-size: 13px; }
.level-color { display: inline-block; width: 16px; height: 16px; border-radius: 3px; margin-right: 8px; }
.level-range { width: 130px; display: inline-block; font-weight: bold; }
.level-name { flex: 1; }

/* 复盘弹窗与顶部间距 */
::v-deep .replay-dialog { margin-top: 10vh !important; }

/* 链接样式（与 Tag.vue 保持一致） */
.name-link { color: #409EFF; text-decoration: none; }
.name-link:hover { text-decoration: underline; }

/* 文本省略样式 */
.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  
  .link-text {
    color: #409EFF;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
}

/* 标签容器样式 */
.tag-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  
  .expand-btn {
    padding: 2px 8px;
    font-size: 12px;
    color: #409EFF;
    height: 24px;
    line-height: 22px;
    
    &:hover {
      background-color: #ecf5ff;
      border-radius: 4px;
    }
  }
}


/* 操作按钮样式（与 Question.vue 保持一致） */
.operation-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  
  .operation-button {
    width: 24px;
    height: 24px;
    padding: 0;
    border-radius: 4px;
    margin: 0;
    border: none;
    transition: all 0.2s ease;
    
    i {
      font-size: 14px;
      color: white;
    }
    
    // 编辑按钮 - 深蓝色
    &.edit-button {
      background-color: #0056b3;
      
      &:hover {
        background-color: #004494;
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
      
      &:active {
        transform: translateY(0);
        background-color: #003d82;
      }
    }
    
    // 订正按钮 - 绿色
    &.fix-button {
      background-color: #67C23A;
      
      &:hover {
        background-color: #5daf34;
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
      
      &:active {
        transform: translateY(0);
        background-color: #529b2e;
      }
    }
    
    // 复盘按钮 - 紫色
    &.replay-button {
      background-color: #6f42c1;
      
      &:hover {
        background-color: #5f3a9f;
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
      
      &:active {
        transform: translateY(0);
        background-color: #4e2a84;
      }
    }
    
    // 收藏按钮（未收藏状态）- 蓝色
    &.collect-button {
      background-color: #409EFF;
      
      &:hover {
        background-color: #337ecc;
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
      
      &:active {
        transform: translateY(0);
        background-color: #2b6cb0;
      }
    }
    
    // 收藏按钮（已收藏状态）- 黄色
    &.collect-active-button {
      background-color: #F7BA2A;
      
      &:hover {
        background-color: #e6a723;
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
      
      &:active {
        transform: translateY(0);
        background-color: #d4951c;
      }
    }
    
    // 挂起按钮（未挂起状态）- 蓝色
    &.pending-button {
      background-color: #409EFF;
      
      &:hover {
        background-color: #337ecc;
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
      
      &:active {
        transform: translateY(0);
        background-color: #2b6cb0;
      }
    }
    
    // 挂起按钮（已挂起状态）- 橙色
    &.pending-active-button {
      background-color: #E6A23C;
      
      &:hover {
        background-color: #d49134;
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      }
      
      &:active {
        transform: translateY(0);
        background-color: #c08025;
      }
    }
    
    // 禁用状态按钮
    &.disabled-button {
      background-color: #F2F3F5;
      cursor: not-allowed;
      opacity: 0.6;
      
      i {
        color: #C0C4CC;
      }
      
      &:hover {
        background-color: #F2F3F5;
        transform: none;
        box-shadow: none;
      }
    }
    
    &:disabled {
      cursor: not-allowed;
      background-color: #F2F3F5;
      opacity: 0.6;
      
      i {
        color: #C0C4CC;
      }
      
      &:hover {
        transform: none;
        box-shadow: none;
      }
    }
  }
}

/* 操作列背景样式 */
::v-deep .operation-column .cell {
  background-color: rgba(248, 249, 250, 0.6) !important;
  padding: 8px 4px !important;
}

</style>

<!-- 全局样式：修复弹窗层级问题，但不影响抽屉 -->
<style>
/* 
  层级结构：
  - 页面内容: z-index: 1
  - 抽屉(无遮罩): z-index: 2001
  - 弹窗遮罩: z-index: 2100
  - 弹窗: z-index: 2101
  - 确认框: z-index: 2200
*/

/* 确保抽屉在正确层级，但没有遮罩 */
.wrongbook-drawer {
  z-index: 2001 !important;
}

/* 只提升从抽屉内触发的弹窗的层级 */
.el-dialog.wrongbook-replay-dialog {
  z-index: 2101 !important;
}

.el-dialog.wrongbook-edit-dialog {
  z-index: 2101 !important;
}

/* 只有弹窗的遮罩层需要提升，抽屉不需要遮罩 */
.el-dialog__wrapper .wrongbook-replay-dialog + .v-modal,
.el-dialog__wrapper .wrongbook-edit-dialog + .v-modal {
  z-index: 2100 !important;
}

/* 确保从抽屉内弹出的dialog wrapper有正确的层级 */
body > .el-dialog__wrapper:has(.wrongbook-replay-dialog),
body > .el-dialog__wrapper:has(.wrongbook-edit-dialog) {
  z-index: 2101 !important;
}

/* 确保确认框在最顶层 */
.el-message-box__wrapper {
  z-index: 2200 !important;
}

/* 确保Message提示也在顶层 */
.el-message {
  z-index: 2300 !important;
}
</style>


